var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLotteryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 6.00065V8.21898C20.6667 9.66732 19.7501 10.584 18.3017 10.584H15.1667V4.17648C15.1667 3.15898 16.0009 2.33398 17.0184 2.33398C18.0176 2.34315 18.9342 2.74648 19.5942 3.40648C20.2542 4.07565 20.6667 4.99232 20.6667 6.00065Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33325 6.91732V19.7507C2.33325 20.5115 3.19492 20.9423 3.79992 20.484L5.36742 19.3106C5.73409 19.0356 6.24742 19.0723 6.57742 19.4023L8.09909 20.9332C8.45659 21.2907 9.04325 21.2907 9.40075 20.9332L10.9408 19.3932C11.2616 19.0723 11.7749 19.0356 12.1324 19.3106L13.6999 20.484C14.3049 20.9332 15.1666 20.5023 15.1666 19.7507V4.16732C15.1666 3.15898 15.9916 2.33398 16.9999 2.33398H6.91659H5.99992C3.24992 2.33398 2.33325 3.97482 2.33325 6.00065V6.91732Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24756 13.0851L11.2526 8.08008",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4308 12.8743H11.4391",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1784 8.29232H6.18663",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotteryIcon);
export default __webpack_public_path__ + "static/media/lottery_icon.c421988e71cd3cdd57b52ed39dee4a00.svg";
export { ForwardRef as ReactComponent };